import './ModelView.scss';

import ModelView from './ModelView';

export default ModelView;
